/*
Describes full application routing of GH Marketplace.
 */

import {prefixPath} from "@web2/prefix_path";

export const apAppPath = prefixPath("/", {
    base: "",
    applications: "zgloszenia/",
    login: "zaloguj/",
    logout: "wyloguj/",
    passwordReset: "przypomnij-haslo/",
    newPassword: "zmien-haslo/:uid([\\w-]+)/:token([\\w-]+)/"
});
